module.exports = __webpack_public_path__ + "images/icons/paid-car-storage-icon.svg";